import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Link } from "@material-ui/core";
import gsap from "gsap";
import MyLink from "../../components/MyLink";
import { CurrentUserContext } from "../../userContext";

const useStyles = makeStyles((theme) => ({
  root: {},
  headerText: {
    fontSize: "16px",
    lineHeight: "24px",
    margin: "20px",
    visibility: "hidden",
    [theme.breakpoints.up("xl")]: {
      fontSize: "20px",
      lineHeight: "28px",
    },
  },
  headerDoubleLines: {
    fontWeight: 700,
    fontStyle: "italic",
  },
}));

function HomePageHeaderText(props) {
  const { currentUser } = React.useContext(CurrentUserContext);

  const textBlockOneRef = React.useRef();
  const textBlockTwoRef = React.useRef();
  const textBlockThreeRef = React.useRef();

  useEffect(() => {
    const textBlockOne = textBlockOneRef.current;
    const textBlockTwo = textBlockTwoRef.current;
    const textBlockThree = textBlockThreeRef.current;

    const mainTL = gsap.timeline();

    mainTL.to(
      [textBlockOne, textBlockTwo, textBlockThree],
      {
        autoAlpha: 1,
        duration: 0.66,
        stagger: 0.1,
      },
      0.3
    );
  }, []);

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography ref={textBlockOneRef} className={classes.headerText}>
        This website <b>showcases</b> just some of the accomplishments and
        skills I have acquired along my journey through life and the world of{" "}
        <i>Information Technology</i> such as: software and hardware I have
        worked on <span className={classes.headerDoubleLines}>||</span>{" "}
        companies and projects I have created or managed{" "}
        <span className={classes.headerDoubleLines}>||</span> testimonials and
        reference letters I have received over the years{" "}
        <span className={classes.headerDoubleLines}>||</span> websites and
        applications I built{" "}
        <span className={classes.headerDoubleLines}>||</span> passion projects I
        designed and created{" "}
        <span className={classes.headerDoubleLines}>||</span> online versions of
        my resume <span className={classes.headerDoubleLines}>||</span> 
        {" "}
        list of skills I possess{" "}
        <span className={classes.headerDoubleLines}>||</span> technical youtube
        videos I have made <span className={classes.headerDoubleLines}>||</span>{" "}
        an online blog I created and maintain{" "}
        <span className={classes.headerDoubleLines}>||</span> a few applications
        I created that are available for sale.{" "}
      </Typography>
      <Typography ref={textBlockTwoRef} className={classes.headerText}>
        With all that said, I can use all these experiences and knowledge to 
        {" "}
         <Link
          href="https://www.programmerondemand.com"
          rel="noopener"
          target="_blank"
          color="secondary"
          className={classes.gridLink}
        >
         {" "}
          help you{" "}
        </Link>
        in many areas of problem solving with technology (my Programmers-on-demand.com website).{" "}
        <MyLink
          path="/skills"
          protectThis={false}
          currentUser={currentUser}
          color="secondary"
          linkText="Please: click here"
        />{" "}
        to see a detailed list of my various skill sets grouped together by category.
      </Typography>

      <Typography ref={textBlockThreeRef} className={classes.headerText}>
        This website explains in words, and visually shows you in 
        {" "}
         <Link
          href="https://www.scottshelpdesk.com/templates/svgfiles/ScottsProjectDiagramFinal10312022.html"
          rel="noopener"
          target="_blank"
          color="secondary"
         > diagrams
         </Link>
         {" "}
        and
        {" "}
        <Link 
         href="#theFlowchart"
         color="secondary"
         rel="noopener"
         target="_blank"
         >
           flowcharts
        </Link>
        {" "}
        my experiences with DevOps and other related technology. I
        explain why it is so important to use various devops practices in
        projects whether you have existing software or are planning on
        undertaking new projects.
        {" "}
        Additionally, here are a few samples of some work I have completed recently.
        {" "}
      <MyLink
          path="/article/thrifting-is-fun"
          protectThis={false}
          currentUser={currentUser}
          target="_blank"
          color="secondary"
          linkText="View Sample Article"
        />
         {" "}
         from my new 
         {" "}
         <Link
          href="https://scottsblog1.netlify.app"
          rel="noopener"
          target="_blank"
          color="secondary"
         >Blog Site
         </Link>
         {" "}
              that I created recently. It is where I will be writing new Blog Articles in the near future about awesome technology!
         {" "}
         <Link
          href="https://crtisit.netlify.app"
          rel="noopener"
          target="_blank"
          color="secondary"
          className={classes.gridLink}
        >
         {" "}
          Click here{" "}
        </Link>
        to see the new CRT IS IT Website that I created using open-source software, javascript, next.js, node.js, postgres, SQLite and the very best Headless CMS called STRAPI. 
        Here you can see my previous Project Diagram (Site Map). 
        {" "}
         <Link
          href="https://www.scottshelpdesk.com/templates/svgfiles/ScottsProjectsOverviewFinal00.html"
          rel="noopener"
          target="_blank"
          color="secondary"
          className={classes.gridLink}
        >
         {" "}
          Old Site Map{" "}
        </Link>
      </Typography>

    </div>
  );
}

export default HomePageHeaderText;
